import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { SlArrowRightCircle } from "react-icons/sl";

const HomeHero = ({ tournament, currentTournamentId, isPrivateAdminView }) => {
  const year = tournament.startDate
    ? tournament.startDate.slice(0, 4)
    : "";

  return (
    <Wrapper className="v-anim-fade-up">
      {isPrivateAdminView && (
        <AdminTag>ADMIN · VISTA PRIVADA</AdminTag>
      )}
      <HeroCard>
        <Eyebrow>
          {year ? `TEMPORADA ${year}` : "LIGA ESPAÑOLA"}
        </Eyebrow>
        <Title>{tournament.name || "LIGA ESPAÑOLA AOE2"}</Title>
        <Subtitle>
          Ya está aquí la nueva temporada, como siempre cargada de
          novedades. Preparad vuestros teclados y ratones porque la
          competencia será feroz.
        </Subtitle>
        <Actions>
          <Link to={`/tournament/${currentTournamentId}`}>
            <button className="v-btn-mint">
              LEER MÁS
            </button>
          </Link>
          {tournament.status === "registers" && (
            <Link to={`/register/tournament/${currentTournamentId}`}>
              <button className="v-btn-outline-mint">
                INSCRÍBETE
              </button>
            </Link>
          )}
          <Link to={`/register/${currentTournamentId}/streamer`}>
            <button className="v-btn-outline-uv">
              <SlArrowRightCircle />
              STREAMER
            </button>
          </Link>
        </Actions>
      </HeroCard>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  opacity: 0;
`;

const AdminTag = styled.div`
  display: inline-block;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  color: var(--v-gold);
  border: 1px solid var(--v-gold-dim);
  border-radius: 4px;
  padding: 4px 10px;
  margin-bottom: 1rem;
`;

const HeroCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 3rem 2.5rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at 20% 50%, rgba(201, 160, 78, 0.06), transparent 60%),
                radial-gradient(ellipse at 80% 50%, rgba(82, 0, 255, 0.06), transparent 60%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 2rem 1.25rem;
  }
`;

const Eyebrow = styled.p`
  font-family: var(--v-font-ui);
  font-size: 19px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1.9px;
  color: var(--v-gold-bright);
  margin: 0 0 0.5rem 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Title = styled.h1`
  font-family: var(--v-font-display);
  font-size: clamp(2.8rem, 7vw, 5rem);
  font-weight: 400;
  line-height: 1.05;
  text-transform: uppercase;
  letter-spacing: 1.07px;
  color: var(--v-white);
  margin: 0 0 1.25rem 0;
`;

const Subtitle = styled.p`
  font-family: var(--v-font-body);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--v-secondary);
  margin: 0 0 2rem 0;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
`;

export default HomeHero;
